// extracted by mini-css-extract-plugin
module.exports = {"show-more":"ShowMore_show-more__IGmib","show-more__button":"ShowMore_show-more__button__vqvPJ"};